import { render } from "./ImageHeader.vue?vue&type=template&id=e754c7b6&ts=true"
import script from "./ImageHeader.vue?vue&type=script&lang=ts"
export * from "./ImageHeader.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./ImageHeader.vue?vue&type=style&index=0&id=e754c7b6&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__